import { Tooltip } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';

interface OwerflowTipProps {
  tipMaxSize: number;
  tooltipMessage: string;
  children: React.ReactNode;
}

const OverflowTip = (props: OwerflowTipProps): React.ReactElement => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef<HTMLDivElement | null>();

  const compareSize = useCallback(() => {
    if (textElementRef.current) {
      const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
      setHover(compare);
    }
  }, []);

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => window.removeEventListener('resize', compareSize);
  }, []);

  return (
    <span>
      <Tooltip arrow title={props.tooltipMessage} disableHoverListener={!hoverStatus}>
        <span
          ref={textElementRef as React.RefObject<HTMLDivElement>}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: `${props.tipMaxSize}px`,
            display: 'inline-block',
          }}
        >
          {props.children}
        </span>
      </Tooltip>
    </span>
  );
};

OverflowTip.displayName = 'Owerflow Tip Component';

export { OverflowTip };
